// extracted by mini-css-extract-plugin
module.exports = {"link":"partners-navigation-module--link--k8cDj","nav":"partners-navigation-module--nav--3unld","activeLink":"partners-navigation-module--activeLink--2_fiE"};